import { Link } from "react-router-dom";

export const HeroNfcLoop = () => {
  return (
    <Link
      to="/configura?prodotto=smart_std_blue"
      className="block group"
      data-testid="hero-banner-link"
      aria-label="Personalizza la tua card — vai al configuratore"
    >
      <div className="italian-demo" data-testid="hero-nfc-loop">
        <div className="relative overflow-hidden rounded-lg bg-black ring-1 ring-[#D4AF37]/20 transition-transform duration-300 group-hover:scale-[1.01] group-hover:ring-[#D4AF37]/40">
          <picture>
            <source media="(max-width: 640px)" srcSet="/assets/hero-banner-mobile.jpg" />
            <img
              src="/assets/hero-banner.jpg"
              alt="InfinityFeedback.com — Più recensioni, più clienti, più successo"
              width="1360"
              height="768"
              loading="eager"
              decoding="async"
              fetchpriority="high"
              className="w-full h-auto block"
              style={{ filter: "brightness(1.1) contrast(1.02)" }}
              data-testid="hero-banner-image"
            />
          </picture>
        </div>
      </div>
    </Link>
  );
};
